(() => {
  'use strict';

  if (customElements.get('collection-model-switcher')) return;

  const SWAP_ATTRS = ['src', 'srcset', 'sizes', 'width', 'height', 'alt'];

  function swapImgAttrs(imgA, imgB) {
    if (!imgA || !imgB) return;
    SWAP_ATTRS.forEach(attr => {
      const temp = imgA.getAttribute(attr);
      imgA.setAttribute(attr, imgB.getAttribute(attr) || '');
      imgB.setAttribute(attr, temp || '');
    });
  }

  function copyAttrsToImg(sourceAttrs, targetImg) {
    if (!targetImg || !sourceAttrs) return;
    SWAP_ATTRS.forEach(attr => {
      targetImg.setAttribute(attr, sourceAttrs[attr] || '');
    });
  }

  function readAttrs(img) {
    if (!img) return null;
    const attrs = {};
    SWAP_ATTRS.forEach(attr => { attrs[attr] = img.getAttribute(attr) || ''; });
    return attrs;
  }

  customElements.define('collection-model-switcher', class extends HTMLElement {
    connectedCallback() {
      this.collection = this.closest('collection-component');
      this.isGhostMode = false;
      this.handleClick = this.handleClick.bind(this);
      this.addEventListener('click', this.handleClick);

      const grid = this.collection?.querySelector('[data-products-grid]');
      if (grid) {
        this.observer = new MutationObserver(() => {
          if (this.isGhostMode) this.applyGhostMode();
        });
        this.observer.observe(grid, { childList: true, subtree: true });
      }
    }

    handleClick(e) {
      const button = e.target.closest('[data-toggle-button]');
      if (!button) return;

      const mode = button.getAttribute('data-toggle-button');
      this.isGhostMode = mode === 'ghost';

      this.querySelectorAll('[data-toggle-button]').forEach(btn =>
        btn.classList.toggle('is-active', btn === button)
      );

      if (this.isGhostMode) {
        this.applyGhostMode();
      } else {
        this.removeGhostMode();
      }
    }

    applyGhostMode() {
      this.collection
        ?.querySelectorAll('[data-has-ghost]:not([data-ghost-swapped])')
        .forEach(card => this.swapCard(card, true));
    }

    removeGhostMode() {
      this.collection
        ?.querySelectorAll('[data-ghost-swapped]')
        .forEach(card => this.swapCard(card, false));
    }

    swapCard(card, enteringGhost) {
      const defaultImg = card.querySelector('[data-product-image-default] img');
      const ghostImg = card.querySelector('[data-product-image-ghost] img');

      const ghostAttrs = enteringGhost ? readAttrs(ghostImg) : null;

      swapImgAttrs(defaultImg, ghostImg);

      const slider = card.querySelector('[data-hover-slider]');
      if (slider) {
        const firstSlideImg = slider.children[0]?.querySelector('img');

        if (enteringGhost && firstSlideImg && ghostAttrs) {
          if (!firstSlideImg.hasAttribute('data-orig-src')) {
            SWAP_ATTRS.forEach(attr => {
              firstSlideImg.setAttribute('data-orig-' + attr, firstSlideImg.getAttribute(attr) || '');
            });
          }

          copyAttrsToImg(ghostAttrs, firstSlideImg);
          slider.scrollLeft = 0;
        } else if (!enteringGhost && firstSlideImg) {
          if (firstSlideImg.hasAttribute('data-orig-src')) {
            SWAP_ATTRS.forEach(attr => {
              firstSlideImg.setAttribute(attr, firstSlideImg.getAttribute('data-orig-' + attr) || '');
            });
          }
        }
      }

      card.toggleAttribute('data-ghost-swapped');
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
      this.observer?.disconnect();
      this.collection = null;
    }
  });
})();
